<template>
	<div  class="hyCheckboxGroup">
		<slot>
			
		</slot>
	</div>
</template>
<script>
	export default {
		name: 'hy-checkbox-group',
		props: {},
		data() {
			return {
			};
		},
		mounted() {

		},
		methods: {
			
		},
		computed: {},
		watch: {},
		components: {},
		updated() {},
		created() {}
	};
</script>
<style>
</style>
